module.exports = __webpack_public_path__ + "static/media/yuki_wu.5885dc31.jpg";